import Router from "vue-router";
import store from "./store";
import Vue from "vue";
import Home from "./views/Home.vue";
import FormVuex from "./views/FormVuex.vue";
import Content from "./views/content.vue";
import Login from "./views/Login.vue";
import LoginCallbackView from "./views/LoginCallbackView.vue";
import Editor from "./views/Editor.vue";

import applicationUserManager from "./Auth/applicationusermanager";

Vue.use(Router);

const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/home",
      name: "home",
      component: Home
    },
    {
      path: "/Editor",
      name: "Editor",
      component: Editor
    },
    {
      path: "/Vuex",
      name: "Vuex",
      component: FormVuex
    },
    {
      path: "/Content/:id",
      name: "Content",
      component: Content,
      meta: {
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: "/Login",
      name: "Login",
      component: Login
    },
    {
      path: "/callback",
      name: "LoginCallbackView",
      component: LoginCallbackView
    },
    {
      path: "/about",
      name: "about",
      component: () =>
        import("./views/About.vue"),
      meta: { noCache: true }
    },
    {
      path: "/home2",
      name: "home2",
      component: () =>
        import("./views/Home2.vue")
    },
    {
      path: "/purchasenotice",
      name: "purchasenotice",
      component: () =>
        import("./views/purchasenotice.vue")
    },
    {
      path: "/purchasedetail",
      name: "purchasedetail",
      component: () =>
        import("./views/purchasedetail.vue")
    },
    {
      path: "/Download",
      name: "Download",
      component: () =>
        import("./views/Download.vue"),
      meta: { noCache: true }
    },
    {
      path: "/Policy",
      name: "Policy",
      component: () =>
        import("./views/Policy.vue")
    },
    {
      path: "/Policydetail",
      name: "Policydetail",
      component: () =>
        import("./views/Policydetail.vue")
    },
    {
      path: "/Guide",
      name: "Guide",
      component: () =>
        import("./views/Guide.vue")
    },
    {
      path: "/Guidedetail",
      name: "Guidedetail",
      component: () =>
        import("./views/Guidedetail.vue")
    },
    {
      path: "/Tender",
      name: "Tender",
      component: () =>
        import("./views/Tender.vue")
    },
    {
      path: "/Tenderdetail",
      name: "Tenderdetail",
      component: () =>
        import("./views/Tenderdetail.vue")
    },
    {
      path: "/Register",
      name: "Register",
      component: () =>
      import("./views/Register.vue")
    },
    {
      path: "/UserCenter",
      name: "UserCenter",
      component: () =>
      import("./views/UserCenter.vue")
    },
    {
      path: "/Enroll",
      name: "Enroll",
      component: () =>
      import("./views/Enroll.vue")
    },
    {
      path: "/Enrolldetail",
      name: "Enrolldetail",
      component: () =>
      import("./views/Enrolldetail.vue")
    },
    {
      path: "/News",
      name: "News",
      component: () =>
      import("./views/News.vue")
    },
    {
      path: "/Newsdetail",
      name: "Newsdetail",
      component: () =>
      import("./views/Newsdetail.vue")
    },
    {
      path: "/Xieyi",
      name: "Xieyi",
      component: () =>
      import("./views/Xieyi.vue")
    },
    {
      path: "/Bidding",
      name: "Bidding",
      component: () =>
      import("./views/Bidding.vue")
    },
    {
      path: "/Biddinglist",
      name: "Biddinglist",
      component: () =>
      import("./views/Biddinglist.vue")
    },
    {
      path: "/ResultNotice",
      name: "ResultNotice",
      component: () =>
      import("./views/ResultNotice.vue")
    },
    {
      path: "/BiddingHistory",
      name: "BiddingHistory",
      component: () =>
      import("./views/BiddingHistory.vue")
    },
    {
      path: "/ResultbcNotice",
      name: "ResultbcNotice",
      component: () =>
      import("./views/ResultbcNotice.vue")
    }
  ]
});

var storeTemp = store;
router.beforeEach((to, from, next) => {
  if (!storeTemp.state.token) {
    storeTemp.commit("saveToken", window.localStorage.Token);
  }
  if (to.meta.requireAuth) {
    // 判断该路由是否需要登录权限
    if (storeTemp.state.token) {
      // 通过vuex state获取当前的token是否存在
      next();
    } else {
      //这里使用Id4授权认证，用Jwt，请删之，并把下边的跳转login 打开；
      applicationUserManager.login();

      //这里使用Jwt登录，如果不用Id4授权认证，这里打开它；
      // next({
      //   path: "/login",
      //   query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
      // });
    }
  } else {
    next();
  }
});

export default router;
